export const getGuardianContactNewsletter = state => state.newsletter.guardianContactNewsletter
